import NiceModal from "@ebay/nice-modal-react";
import { styled, tooltipClasses, TooltipProps } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import clsx from "clsx";
import { useContext } from "react";
import { NavLink } from "react-router-dom";
import { useRecoilValue } from "recoil";

import { ReactComponent as BellIcon } from "assets/icons/nav/bell.svg";
import { ReactComponent as HomeIcon } from "assets/icons/nav/home.svg";
import { ReactComponent as MessageIcon } from "assets/icons/nav/message.svg";
import { ReactComponent as MonitorIcon } from "assets/icons/nav/monitor.svg";
import { ReactComponent as NoticeIcon } from "assets/icons/nav/notice.svg";
import { ReactComponent as ProfileIcon } from "assets/icons/nav/profile.svg";
import { ReactComponent as SettingIcon } from "assets/icons/nav/setting.svg";
import { userState } from "store/store";
import FaqModal from "./modals/FaqModal";
import NoticeModal from "./modals/NoticeModal";

const NavTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} placement="right" arrow />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "black",
    color: "white",
    fontSize: theme.typography.pxToRem(13),
    padding: "3px 6px",
    marginLeft: "0.688rem!important",
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: "black",
  },
}));

const SideNav = () => {
  const user = useRecoilValue(userState);
  const niceModalContext = useContext(NiceModal.NiceModalContext);

  const openNotice = () => {
    const modals = Object.keys(niceModalContext);
    modals.forEach((key) => {
      if (NiceModal.getModal(key)?.displayName !== "NoticeModal") {
        NiceModal.hide(key);
      }
    });
    if (modals.length) {
      setTimeout(() => {
        NiceModal.show(NoticeModal);
      }, 100);
    } else {
      NiceModal.show(NoticeModal);
    }
  };

  const openHelp = () => {
    const modals = Object.keys(niceModalContext);
    modals.forEach((key) => {
      if (NiceModal.getModal(key)?.displayName !== "FaqModal") {
        NiceModal.hide(key);
      }
    });
    if (modals.length) {
      setTimeout(() => {
        NiceModal.show(FaqModal);
      }, 100);
    } else {
      NiceModal.show(FaqModal);
    }
  };

  return (
    <nav className="fixed z-40 h-full overflow-auto top-0 bg-secondary">
      <div className="min-h-[720px] h-full flex flex-col justify-between">
        <ul className="space-y-5 pt-[8.375rem]">
          <li>
            <NavTooltip title="대시보드">
              <span>
                <NavLink
                  to="/"
                  className={({ isActive }) =>
                    clsx(
                      "inline-flex justify-center items-center size-[3.5rem] duration-100 hover:bg-[#4B535F]",
                      { "bg-[#4B535F]": isActive },
                    )
                  }
                >
                  <HomeIcon className="size-5" />
                </NavLink>
              </span>
            </NavTooltip>
          </li>
          <li>
            <NavTooltip title="QnA관리">
              <span>
                <NavLink
                  to="/qna"
                  className={({ isActive }) =>
                    clsx(
                      "inline-flex justify-center items-center size-[3.5rem] duration-100 hover:bg-[#4B535F]",
                      { "bg-[#4B535F]": isActive },
                    )
                  }
                >
                  <MessageIcon className="size-6" />
                </NavLink>
              </span>
            </NavTooltip>
          </li>
          {[1, 2].includes(user!.grade.id) && (
            <li>
              <NavTooltip title="모니터링">
                <span>
                  <NavLink
                    to="/monitoring"
                    className={({ isActive }) =>
                      clsx(
                        "inline-flex justify-center items-center size-[3.5rem] duration-100 hover:bg-[#4B535F]",
                        { "bg-[#4B535F]": isActive },
                      )
                    }
                  >
                    <MonitorIcon className="size-6" />
                  </NavLink>
                </span>
              </NavTooltip>
            </li>
          )}
          {user?.grade.id === 1 && (
            <li>
              <NavTooltip title="서비스관리">
                <span>
                  <NavLink
                    to="/settings"
                    className={({ isActive }) =>
                      clsx(
                        "inline-flex justify-center items-center size-[3.5rem] duration-100 hover:bg-[#4B535F]",
                        { "bg-[#4B535F]": isActive },
                      )
                    }
                  >
                    <SettingIcon className="size-6" />
                  </NavLink>
                </span>
              </NavTooltip>
            </li>
          )}
        </ul>
        <ul className="space-y-5 py-6">
          <li>
            <NavTooltip title="내정보">
              <span>
                <NavLink
                  to="/my"
                  className={({ isActive }) =>
                    clsx(
                      "inline-flex justify-center items-center size-[3.5rem] duration-100 hover:bg-[#4B535F]",
                      { "bg-[#4B535F]": isActive },
                    )
                  }
                >
                  <ProfileIcon className="size-6" />
                </NavLink>
              </span>
            </NavTooltip>
          </li>
          <li>
            <NavTooltip title="공지사항">
              <span>
                <button
                  type="button"
                  className="inline-flex justify-center items-center size-[3.5rem] duration-100 hover:bg-[#4B535F]"
                  onClick={openNotice}
                >
                  <BellIcon className="size-6" />
                </button>
              </span>
            </NavTooltip>
          </li>
          <li>
            <NavTooltip title="도움말">
              <span>
                <button
                  type="button"
                  className="inline-flex justify-center items-center size-[3.5rem] duration-100 hover:bg-[#4B535F]"
                  onClick={openHelp}
                >
                  <NoticeIcon className="size-6" />
                </button>
              </span>
            </NavTooltip>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default SideNav;
